
import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, input, OnInit, Signal } from '@angular/core';
import { ICON_PATH_TOKEN } from './icon-pass.token';

@Component({
  selector: 'csl-icon',
  standalone: true,
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'inline-block bg-0-level-current',
  },
})
export class IconComponent implements OnInit {
  private readonly el = inject(ElementRef);
  private readonly iconPath = inject(ICON_PATH_TOKEN);

  name = input.required<string>();
  iconUrl: Signal<string> = computed(() => `url(${this.iconPath}/${this.name()}.svg)`);

  ngOnInit(): void {
    if (!this.iconPath) {
      console.warn('ICON_PATH_TOKEN is not provided');
      return;
    }

    if (!this.name()) {
      console.warn('icon name is not provided');
      return;
    }

    this.el.nativeElement.style.maskImage = this.iconUrl();
    this.el.nativeElement.style.maskSize = 'contain';
    this.el.nativeElement.style.maskRepeat = 'no-repeat';
  }
}
